import React from 'react';
import Reveal from '../Reveal/Reveal';
import PhotoBrief from '../PhotoBrief/PhotoBrief';
import galleryAlbums from '../../content/galleryAlbums';
import './GalleryPage.scss';

const STAGGER_CAP = 8;

// Every record — real photo or PhotoBrief — is one tile in a mosaic grid.
// `record.size` ('large' | 'wide' | 'tall' | undefined) sets how many
// rows/columns the tile spans (see GalleryPage.scss); undefined is one
// small square unit.
function GalleryRecord({ record, index }) {
    const sizeClass = record.size ? ` GalleryPage-item--${record.size}` : '';

    return (
        <Reveal
            as="li"
            variant="plate"
            index={Math.min(index, STAGGER_CAP)}
            className={`GalleryPage-item${sizeClass}`}
        >
            {record.src ? (
                <img
                    className="GalleryPage-photo"
                    src={record.src}
                    alt={record.alt}
                    loading="lazy"
                    decoding="async"
                />
            ) : (
                <PhotoBrief
                    className="GalleryPage-brief"
                    role={record.photoRole}
                    context={record.context}
                />
            )}
        </Reveal>
    );
}

function GalleryPage() {
    return (
        <div className="GalleryPage">
            <header className="GalleryPage-header">
                <Reveal as="h1" variant="rise" className="GalleryPage-title">
                    Gallery
                </Reveal>
            </header>

            <ul className="GalleryPage-grid">
                {galleryAlbums.map((record, index) => (
                    <GalleryRecord key={record.id} record={record} index={index} />
                ))}
            </ul>
        </div>
    );
}

export default GalleryPage;
